var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"main main-users"},[_c('iframe',{ref:"wikiFrame",staticClass:"wiki-iframe",attrs:{"src":"https://wiki.dexfreedom.com/?cmd=hideLogo"},on:{"load":_vm.handleLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }